// @flow
import * as classNames from 'classnames';
import * as React from 'react';
import { IValidatorPackage } from '../../Validators';
import MaskedInput from 'react-text-mask';
import { withLocalize, Translate } from "react-localize-redux";
import { toast, Flip } from 'react-toastify';

import './TextField.css';

interface ITextFieldProps {
    required?: boolean;
    mask?: string[];
    deferErrors: boolean;
    label: string;
    value: string;
    isDate?: boolean;
    handleOnChange: React.ChangeEventHandler<HTMLInputElement>;
    handleOnFocus?: React.FocusEventHandler<HTMLInputElement>;
    handleOnBlur?: React.FocusEventHandler<HTMLInputElement>;
    validators?: IValidatorPackage[];
    className?: string;
    placeholder?: string;
    placeholderIsTranslation?: boolean;
    id: string;
    ref: string;
    type?: string;
    autoFocus?: boolean;
    autoComplete?: boolean;
    partialAllowedRegex?: string;
}

interface ITextFieldState {
    touched: boolean;
}

class TextField extends React.PureComponent<ITextFieldProps, ITextFieldState> {
    constructor(props: ITextFieldProps) {
        super(props);
        this.state = {
            touched: false
        };
    }

    toastId = null;
    lastToast = toast.TYPE.WARN;

    onChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
        // This will perform a partial allowed regex match, and so long as the string is continuing to be partially valid it will work
        if (this.props.partialAllowedRegex !== undefined && e.currentTarget.value !== '') {
            // const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (!this.props.partialAllowedRegex.test(e.currentTarget.value)) {
                e.currentTarget.value = this.props.value || '';
                // e.currentTarget.value = e.currentTarget.value.replace(this.props.allowedRegex, '');
                // console.log('removed spaces');
                if (! toast.isActive(this.toastId)) {
                    toast.dismiss();
                    this.toastId = toast.warn(<Translate id="online_waiver_js.invalid_field"/>, {
                        autoClose: 2000,
                        position:  toast.POSITION.BOTTOM_CENTER,
                        className: "invalid-field",
                        transition: Flip
                    });
                } else {
                    this.lastToast = (this.lastToast === toast.TYPE.ERROR) ? toast.TYPE.WARNING : toast.TYPE.ERROR;
                    toast.update(this.toastId, {
                        type: this.lastToast,
                        autoClose: 2000
                    })
                }
            }

        }
        this.props.handleOnChange(e);
    }

    onBlurInput = (e: SyntheticFocusEvent<HTMLInputElement>) => {
        this.setState({
            touched: true
        });
        this.props.handleOnBlur && this.props.handleOnBlur(e);
    }

    onFocusInput = (e: SyntheticFocusEvent<HTMLInputElement>) => {
        this.props.handleOnFocus && this.props.handleOnFocus(e);
    }

    getInputOrMask = () => {
        if (this.props.mask) {
            return (
                <Translate>
                { ({translate}) =>
                <MaskedInput
                    mask={this.props.mask}
                    className={'TextField-input'}
                    type={this.props.type || 'text'}
                    aria-label={this.props.label}
                    id={this.props.id}
                    ref={this.props.ref}
                    value={this.props.value}
                    onFocus={() => this.props.handleOnFocus}
                    onBlur={(e) => {
                        this.setState({ [this.props.id + 'Touched']: true });
                        this.onBlurInput(e);
                    }}
                    onChange={e => { this.onChangeInput(e); }}
                    autoFocus={this.props.autoFocus ? true : false}
                    placeholder={(this.props.placeholderIsTranslation === true) ? translate(this.props.placeholder) : this.props.placeholder}
                    guide={{ textTransform: false}}
                    style={{ textTransform: '' }}
                    autoComplete={this.props.autoComplete}
                />
                }
                </Translate>
            )
        } else {
            return (
                <Translate>
                { ({translate}) =>
                    <input
                        className={'TextField-input'}
                        type={this.props.type || 'text'}
                        aria-label={this.props.label}
                        autoCorrect={this.props.isDate ? 'false' : 'true'}
                        autoComplete={this.props.isDate ? 'false' : 'true'}
                        value={this.props.value}
                        onFocus={this.onFocusInput}
                        onBlur={this.onBlurInput}
                        onChange={this.onChangeInput}
                        placeholder={(this.props.placeholderIsTranslation === true) ? translate(this.props.placeholder) : this.props.placeholder}
                        maxLength={this.props.isDate ? 10 : 100}
                    />
                }
                </Translate>
            )
        }
    }

    render() {
        let valid = true;
        let errorMsg = '';
        if (this.props.validators) {
            this.props.validators.forEach((validatorPackage) => {
                if (!valid) {
                    return;
                }
                if (validatorPackage.validator(this.props.value) === false) {
                    valid = false;
                    errorMsg = validatorPackage.errorMessage;
                }
            });    
        }
        const showError = !valid && (this.props.deferErrors === false);
        const textFieldClasses = classNames('TextField', this.props.className || '', {
            'TextField--error': showError
        });
        //console.log(textFieldClasses);
        // console.log(this.props.label && this.props.label.props.id + ' ' + this.props.required);
        // console.log(this.props.required && (
            // "<span className={'TextField-required'}>{' *'}</span>"
        // ));
        return (
            <div className={textFieldClasses}>
                <div className={'TextField-label'}>
                    {this.props.label}
                    {this.props.required && (
                        <span className={'TextField-required'}>{' *'}</span>
                    )}
                </div>
                {this.getInputOrMask()}
                {showError && (
                    <div className={'TextField-error'}>{errorMsg}</div>
                )}
            </div>
        );
    }
}

export default withLocalize(TextField);
// export default TextField;
